<template>
  <div v-if="hasPermission(permissions.reportsForgivePrice)">
    <content-header>{{ $t('partialPaymentReport') }}</content-header>
    <v-content>
      <h5> {{ $t('total') }}: {{ totalPartialPrice.toLocaleString() }}</h5>
      <BootstrapTable
          :rows="rows"
          :columns="columns"
          :config="config"
          :total-rows="totalRecords"
          :actions="actions"
          @on-change-query="onChangeQuery"
      >
        <template slot="empty-results">{{ $t('noResultsFound') }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0">{{ totalRecords }} {{ $t('totalRecords') }}</template>
          <template v-else>{{ $t('noResultsFound') }}</template>
        </template>
        <template slot="buyContractId" slot-scope="props">
          <router-link :to="{name: 'buyContracts.show', params: {id: props.row.buyContractId}}">{{ props.row.buyContractId }}</router-link>
        </template>
        <template slot="partialPrice" slot-scope="props">
          {{ parseFloat(props.row.partialPrice).toLocaleString() }}
        </template>
        <template slot="partialDate" slot-scope="props">
          {{ formatDate(props.row.partialDate) }}
        </template>
        <template slot="partialDeadline" slot-scope="props">
          {{ formatDate(props.row.partialDeadline) }}
        </template>
        <template slot="currentPayDate" slot-scope="props">
          {{ formatDate(props.row.currentPayDate) }}
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import IsLoading from "@/components/IsLoading";
import {permissions, serverParams, tableActions, tableConfigure} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";
import {PartialPaymentReport} from "@/models/PartialPaymentReport";

export default {
  name: "PartialPaymentReport",
  components: {IsLoading, 'v-content': Content, ContentHeader, BootstrapTable},
  data() {
    return {
      isLoading: false,
      model: new PartialPaymentReport(),
      columns: [],
      rows: [],
      actions: tableActions(false),
      totalRecords: 0,
      config: tableConfigure(this.$t('partialPaymentReport'), true, false),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions,
      totalPartialPrice: 0,
    }
  },
  beforeMount() {
    this.columns  = this.model.getColumns();
  },
  mounted() {
    this.loadData(true);
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start   = 0
        serverParams._end     = 10
        serverParams._sort    = ''
        serverParams._order   = ''
        serverParams._search  = ''
        serverParams.custom_params  = ''
      }
      this.isLoading = true;
      this.serverParams.fromDate  = this.fromDate;
      this.serverParams.toDate    = this.toDate;
      this.$store.dispatch('reports/GET_PARTIAL_PAYMENT_REPORT', this.serverParams)
          .then((response) => {
            this.rows               = response.data
            this.totalRecords       = parseInt(response.headers['x-total-count']);
            this.totalPartialPrice  = parseFloat(response.headers['totalpartialprice']);
            this.isLoading          = false
          })
          .catch(() => this.isLoading = false);
    },
    onChangeQuery(queryParams) {
      serverParams._start   = (queryParams.page - 1) * queryParams.per_page
      serverParams._end     = queryParams.page * queryParams.per_page
      serverParams._sort    = queryParams.sort[0] ? queryParams.sort[0].name : ''
      serverParams._order   = queryParams.sort[0] ? queryParams.sort[0].order : ''
      serverParams._search  = queryParams.global_search ?? ''
      this.loadData();
    },
  }
}
</script>
